import { ForwardCanvasMouseEventsDirective } from '@adaptiva/canvas';
import { pwaGuard } from '@adaptiva/core/pwa';
import { themeSetupGuard } from '@adaptiva/core/themes';
import { autoLoginGuard, existingSessionGuard, systemConfigSetupGuard } from '@adaptiva/data-service';
import { AdaptivaLogoComponentModule } from '@adaptiva/widgets/adaptiva-logo';
import { AppShellNoMenuComponent, toggleSplashGuard } from '@adaptiva/widgets/app-shell';
import { LoginFormComponent, LoginFormComponentModule } from '@adaptiva/widgets/login-form';
import { TileGraphicModule } from '@adaptiva/widgets/tile-graphic';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { of } from 'rxjs';
import { LoginComponent } from './login.component';

@NgModule({
	imports: [
		AdaptivaLogoComponentModule,
		CommonModule,
		ForwardCanvasMouseEventsDirective,
		LoginFormComponentModule,
		RouterModule.forChild([
			{
				path: 'login',
				title: 'Login',
				canActivate: [
					pwaGuard,
				],
				component: AppShellNoMenuComponent,
				children: [
					{
						path: '',
						component: LoginComponent,
						canActivate: [
							systemConfigSetupGuard,
							themeSetupGuard,
						],
						children: [
							{
								path: '',
								component: LoginFormComponent,
								canActivate: [
									existingSessionGuard('/login'),
									autoLoginGuard,
								],
							},
							{
								path: 'register',
								loadChildren: () => import('./cloud/register/cloud-registration.module').then(m => m.CloudRegistrationModule),
								canActivate: [toggleSplashGuard(() => of(true))],
							},
							{
								path: 'reset-password',
								loadChildren: () => import('./reset-password').then(m => m.ResetPasswordModule),
								canActivate: [toggleSplashGuard(() => of(true))],
							},
						]
					},
					{
						path: 'oidc-redirect',
						loadChildren: () => import('./oidc-redirect').then(m => m.OidcRedirectModule),
						canActivate: [toggleSplashGuard(() => of(true))],
					},
					{
						path: 'oidc-register',
						loadChildren: () => import('./oidc-register').then(m => m.OidcRegisterModule),
						canActivate: [toggleSplashGuard(() => of(true))],
					},
					{
						path: 'saml',
						loadComponent: () => import('./saml').then(c => c.SamlLoginComponent),
						canActivate: [toggleSplashGuard(() => of(true))],
					}
				]
			},
			{
				path: 'signout',
				loadComponent: () => import('./signout').then(m => m.SignoutComponent),
				canActivate: [toggleSplashGuard(() => of(true))],
			},
			{
				path: 'error',
				title: 'Error',
				loadChildren: () => import('../../views/error/error-view.module').then(m => m.ErrorViewModule),
				canActivate: [toggleSplashGuard(() => of(true))],
			},
		]),
		TileGraphicModule,
	],
	declarations: [LoginComponent],
	exports: [LoginComponent]
})
export class LoginModule {

}
